import React, { useCallback, useContext } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import usePopup from 'hooks/usePopup';
import { Option } from 'kingpin/atoms/ContextMenu';
import ContextMenuContext from 'kingpin/atoms/ContextMenu/ContextMenuContext';

import ManageEntityAppsPopup from './ManageEntityAppsPopup';

const ManageEntityAppsOption = ({
  entity,
}: {
  entity: EntityDetails.Entity;
}) => {
  const { closeMenu } = useContext(ContextMenuContext);
  const { isOpen, open, close } = usePopup();
  const onClose = useCallback(() => {
    close();
    closeMenu();
  }, [close, closeMenu]);

  return (
    <>
      <Option
        label={'Manage Entity Apps'}
        onClick={open}
        testId={`manage-${entity.id}-entities`}
        shouldHideInsteadOfCloseMenu
      />
      <ModalTransition>
        {isOpen && (
          <Modal
            shouldScrollInViewport={false}
            autoFocus={false}
            onClose={onClose}
          >
            <ManageEntityAppsPopup entity={entity} close={onClose} />
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default ManageEntityAppsOption;
